import { createSelector } from "reselect"
import { computeFilterChips } from "helpers/filters/chips"
import { getFilter, getClassifications, getSecuritiesDescriptors, getPortfolioFilters } from "./filters"
import { getTagCategories, getAttributeCategories } from "modules/portfolio-root/selectors"
import { getCurrency } from "modules/portfolio-root/selectors/portfolios"

export const getChips = createSelector(
  [getFilter, getTagCategories, getClassifications, getSecuritiesDescriptors, getPortfolioFilters, getAttributeCategories, () => {}, getCurrency],
  computeFilterChips,
)
